import React from 'react';

export let Split = ({n, children}) => {
  if (!n)
    return <div className="grid grid-cols-2 gap-8">
      {children}
    </div>
}

export default ({l, r, children, ...props}) => <div className="h-space" {...props}>
  <div>{l || (children && children[0])}</div>
  <div>{r || (children && children[1])}</div>
</div>